import { useNavbarContext } from 'contexts/NavbarContext';
import React from 'react';
import { PRODUCTOS } from 'utils/constants';
import ResumenTravelEmpresa from '../../components/TravelMex/ResumenTravelEmpresa';

const ContainerTravelEmpresaResumen = (props) => {
  useNavbarContext(PRODUCTOS.TRAVELBTA);
  return (
    <main className="bg-light">
      <div className="cr-content container-fluid">
        <ResumenTravelEmpresa {...props} />
      </div>
    </main>
  );
};

export default ContainerTravelEmpresaResumen;
